import { combineReducers } from 'redux';
import * as types from './types';
import initialState from './initialState';

const outageBannerReducer = (state = initialState.entities, action) => {
  switch (action.type) {
    case types.GET_OUTAGE_BANNER_DETAILS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const getBannerOutageDetailsReducer = (state = initialState.getOutageBannerDetails, action) => {
  switch (action.type) {
    case types.GET_OUTAGE_BANNER_DETAILS_BEGIN:
      return {
        ...state,
        hasFetched: false,
        isLoading: true
      };
    case types.GET_OUTAGE_BANNER_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        hasFetched: false,
        error: action.payload
      };
    case types.GET_OUTAGE_BANNER_DETAILS_SUCCESS:
      return {
        ...state,
        hasFetched: true,
        isLoading: false
      };
    default:
      return state;
  }
};

const reducer = combineReducers({
  entities: outageBannerReducer,
  getOutageBannerDetails: getBannerOutageDetailsReducer
});

export default reducer;
